import { Card, CardContent, Typography, Box, Avatar, Stack, IconButton, Divider } from '@mui/material';
import { Mail, Phone, MoreVertical, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '@/router/paths';
import { DepartmentBadge } from './DepartmentBadge';

export function TeacherCard({ teacher, basePath = PATHS.TEACHER_DIRECTORY }) {
  const navigate = useNavigate();

  return (
    <Card 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
          cursor: 'pointer'
        }
      }}
      onClick={() => navigate(`${basePath}/${teacher.id}`)}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Avatar 
            src={teacher.photo} 
            sx={{ width: 64, height: 64, bgcolor: 'primary.main', fontSize: 24 }}
          >
            {teacher.firstName.charAt(0)}
          </Avatar>
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); /* Menu logic */ }}>
            <MoreVertical size={20} />
          </IconButton>
        </Stack>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          {teacher.firstName} {teacher.lastName}
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {teacher.designation}
        </Typography>

        <Box mb={2}>
          <DepartmentBadge department={teacher.department} />
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', color: 'text.secondary' }}>
            <Mail size={16} />
            <Typography variant="body2" noWrap title={teacher.email}>
              {teacher.email}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', color: 'text.secondary' }}>
            <Phone size={16} />
            <Typography variant="body2">
              {teacher.phone}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
